module.exports = __webpack_public_path__ + "img/bagsBa.eea08b52.png";